module.exports = __webpack_public_path__ + "img/Lora_ttn.d3ce66cd.png";